import { useRef } from 'react';

import { XYChartTooltipContent } from './XYChartTooltipContent.js';
import { XYChartTooltipTemplate } from './XYChartTooltipTemplate/XYChartTooltipTemplate.js';
import {
  useContentState,
  usePinnedState,
  usePositionState,
} from '../../store/selectors.js';

export const XYChartTooltip = () => {
  const ref = useRef<HTMLDivElement>(null);
  const pinned = usePinnedState();
  const position = usePositionState();
  const content = useContentState();

  const isGap = !content.datapoint || !content.series;

  if (!position || isGap) {
    return null;
  }

  return (
    <XYChartTooltipTemplate
      ref={ref}
      position={position.absolute}
      pinned={pinned}
    >
      <XYChartTooltipContent />
    </XYChartTooltipTemplate>
  );
};

XYChartTooltip['displayName'] = 'XYChartTooltip';
